<template>
    <div class="grid-fitted grid-unstackable">
        <div class="grid-item no-flex">
            <v-avatar :initials="initials"/>
        </div>
        <div class="grid-item">
            <div class="timeline-comment-message-bubble tile break-all">
                <div class="grid-fitted grid-unstackable">
                    <div class="grid-item stack-s">
                        <strong class="inline-s">{{authorFullName}}</strong>
                        <a
                            class="text-muted timeline-message-time"
                            :title="message.dateTime"
                            :href="`#${message.anchorId}`">{{message.time}}</a>
                    </div>
                    <div class="grid-item no-flex" v-if="canDelete">
                        <v-icon-button type="basic" size="small" @click="$emit('delete')">
                            <v-icon icon="close-s"/>
                        </v-icon-button>
                    </div>
                </div>
                <div class="grid-fitted">
                    <div class="grid-item grid-item-full timeline-comment-message-chunks"
                         :class="{'stack-m' : message.hasAttachments}">
                        <!--In order to create links to resource/mentions using a router-link
                            message has to be brake in chunks and render the parts separately.-->
                        <template v-for="(chunk, index) in messageChunks">
                            <template v-if="chunk.type === 'action'">
                                <a :data-action-name="chunk.name" href="#" :key="`${index}-${chunk.name}`"
                                   @click.prevent="handleMessageAction">{{chunk.text}}</a>
                            </template>
                            <template v-else-if="chunk.type === 'resource'">
                                <router-link v-if="chunk.route"
                                             :to="chunk.route"
                                             :key="`${index}-${chunk.id}`">{{chunk.id}}
                                </router-link>
                                <a v-else
                                   href="#" :key="`${index}-${chunk.id}`">{{chunk.id}}</a>
                            </template>
                            <span v-else-if="chunk.type === 'text'" :key="`${index}-${chunk.id}`">{{chunk.text}}</span>
                            <span v-else v-html="chunk.text" :key="`${index}-${chunk.id}`"><!--Only html entities should render here--></span>
                        </template>
                    </div>
                    <div v-if="message.hasAttachments" class="grid-item grid-item-full break-all">
                        <ul class="list list-group list-compact">
                            <li class="list-item"
                                v-for="(attachment, index) in message.attachments"
                                :key="`${attachment.relatedId}-${index}`">
                                <span class="no-flex">
                                    <v-icon :icon="getAttachmentIcon(attachment)" class="inline-s"
                                            :class="{'is-spinning icon-light-gray': attachment.isTransfering}"/>
                                    <r-button type="link"
                                              @click="$emit('download-attachment', attachment)"
                                              :disabled="attachment.hasError"
                                    >{{attachment.name}}</r-button>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vAvatar from '@/components/v-avatar';
    import stripHTML from '@/common/helpers/strip-html';
    import {vIcon, vIconButton} from '@/components/form';
    import messagesMixins from './messages-mixins';
    import SuggestionProviders from '../comments/suggestion-providers';
    import commentHelper from '../comments/comment-helper';

    export default {
        name: 'comment-message',
        mixins: [messagesMixins],
        components: {
            vIconButton,
            vIcon,
            vAvatar,
        },
        computed: {
            author() {
                return this.message.author || {};
            },
            authorFullName() {
                return this.author.userFullName || '';
            },
            initials() {
                // This most probably change. I request a backend change.
                const [firstName, lastName] = this.authorFullName.split(' ');
                return `${firstName[0]}${lastName[0]}`;
            },
            canDelete() {
                return this.$store.getters['user/userId'] === this.author.userId;
            },
            messageChunks() {
                const noMarkupComment = stripHTML(this.message.message);
                return commentHelper.plainTextToIterableHTML(noMarkupComment, SuggestionProviders);
            },
        },
        methods: {
            getAttachmentIcon({name, isTransfering, hasError}) {
                const icons = {
                    error: 'close',
                    loading: 'loading',
                    pdf: 'file',
                    jpg: 'file',
                    png: 'file',
                    fallbackExt: 'file',
                };
                if (isTransfering) {
                    return icons.loading;
                }
                if (hasError) {
                    return icons.error;
                }
                const fileExt = name.split('.').pop().toLowerCase();
                return icons[fileExt] || icons.fallbackExt;
            },
            handleMessageAction(e) {
                const {actionName} = e.target.dataset;
                switch (actionName) {
                    case '@Rebilly':
                        // timeline @Rebilly link click action
                        this.triggerIntercomEvent({
                            name: 'Timeline Rebilly Mention Triggered',
                            meta: {
                                note: this.message.message,
                            },
                        });
                        break;
                    default:
                        break;
                }
            },
        },
    };
</script>
